import u from "./ghl-ui.es796.js";
import r from "./ghl-ui.es745.js";
function m(i, n, f, s, t) {
  return i === n ? !0 : i == null || n == null || !r(i) && !r(n) ? i !== i && n !== n : u(i, n, f, s, m, t);
}
export {
  m as default
};
